// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backButton":"_3_KuS8","button":"_2mQieh","closeButton":"YKwpEN","content":"A3wJif","navContainer":"_3yRc9l"};